import { Controller } from "@hotwired/stimulus";

// Lowercases a text field on blur, matching the reference-data convention for fields that are
// always lowercase (treasure codes, spell range/duration/save). Tokens listed in the `keep`
// value stay uppercase (e.g. the JPS/JPD/JPC saving-throw prefixes on spells).
// Connects to data-controller="downcase"
export default class extends Controller {
	static values = { keep: { type: Array, default: [] } };

	normalize() {
		let value = this.element.value.toLowerCase();
		for (const token of this.keepValue) {
			value = value.replace(new RegExp(`\\b${token}\\b`, "gi"), token);
		}
		this.element.value = value;
	}
}
